module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {}, [_c('hd-header'), _vm._v(" "), _c('section', {
    staticClass: "hd-web-content"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('hd-footer')], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "banner"
  }, [_c('div', {
    staticClass: "wrap",
    staticStyle: {
      "position": "relative",
      "height": "100%"
    }
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("我要讲课")]), _vm._v(" "), _c('div', {
    staticClass: "line"
  }), _vm._v(" "), _c('div', {
    staticClass: "en"
  }, [_vm._v("THE THREE MAJOR ADVANTAGES")]), _vm._v(" "), _c('div', {
    staticClass: "tip"
  }, [_vm._v("入驻海渡职校坐享三大优势")]), _vm._v(" "), _c('div', {
    staticClass: "fenlei clear"
  }, [_c('div', {
    staticClass: "item"
  }, [_c('img', {
    attrs: {
      "src": require("assets/images/icon_yingxiao.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('h3', [_vm._v("精准营销")]), _vm._v(" "), _c('p', [_c('span', [_vm._v("全网独家专注工业机器人")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v("教育细分领域")])])]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('img', {
    attrs: {
      "src": require("assets/images/icon_shenyuan.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('h3', [_vm._v("海量生源")]), _vm._v(" "), _c('p', [_c('span', [_vm._v("海渡职校全国分院地面教学")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v("保障线上生源")])])]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('img', {
    attrs: {
      "src": require("assets/images/icon_shouyi.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('h3', [_vm._v("多重收益")]), _vm._v(" "), _c('p', [_c('span', [_vm._v("点播与直播课程对应收益")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v("高额回馈与奖励")])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "block zg"
  }, [_c('div', {
    staticClass: "wrap"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("入驻资格")]), _vm._v(" "), _c('div', {
    staticClass: "line"
  }), _vm._v(" "), _c('div', {
    staticClass: "tip"
  }, [_vm._v("什么资格可以成功开课")]), _vm._v(" "), _c('div', {
    staticClass: "list clear"
  }, [_c('div', {
    staticClass: "item"
  }, [_c('img', {
    attrs: {
      "src": require("assets/images/icon_geren.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('h3', [_vm._v("个人")]), _vm._v(" "), _c('p', [_vm._v("工业机器人相关课程的院校老师")]), _vm._v(" "), _c('p', [_vm._v("制造业、自动化行业资深工程师")])]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('img', {
    attrs: {
      "src": require("assets/images/icon_jigou.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('h3', [_vm._v("机构")]), _vm._v(" "), _c('p', [_vm._v("营业执照标有教育、培训、咨询类机构用户")]), _vm._v(" "), _c('p', [_vm._v("开设课程属于工业机器人教育或相关衍生领域")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "block lc"
  }, [_c('div', {
    staticClass: "wrap"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("入驻和上课流程")]), _vm._v(" "), _c('div', {
    staticClass: "line"
  }), _vm._v(" "), _c('div', {
    staticClass: "tip"
  }, [_vm._v("入驻和开课都需要哪些流程?")]), _vm._v(" "), _c('div', {
    staticClass: "list clear"
  }, [_c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "step"
  }, [_vm._v("1")]), _vm._v(" "), _c('h3', [_vm._v("信息提交")]), _vm._v(" "), _c('p', [_vm._v("填写海渡职校入驻申请信息")])]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "step"
  }, [_vm._v("2")]), _vm._v(" "), _c('h3', [_vm._v("资格认可")]), _vm._v(" "), _c('p', [_vm._v("3个工作日内进行认证")])]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "step"
  }, [_vm._v("3")]), _vm._v(" "), _c('h3', [_vm._v("合同签订")]), _vm._v(" "), _c('p', [_vm._v("海渡工作人员和您签订合约")])]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "step"
  }, [_vm._v("4")]), _vm._v(" "), _c('h3', [_vm._v("课程上线")]), _vm._v(" "), _c('p', [_vm._v("课程上线培训指导")])])]), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_c('h2', {
    staticClass: "title"
  }, [_vm._v("入驻信息提交")]), _vm._v(" "), _c('div', {
    staticClass: "line-title"
  }, [_vm._v("1. 邮件标题：")]), _vm._v(" "), _c('div', {
    staticClass: "line-content"
  }, [_vm._v("\n            机构/个人名称-入驻申请资料\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "line-title"
  }, [_vm._v("2. 邮件内容：")]), _vm._v(" "), _c('div', {
    staticClass: "line-content"
  }, [_c('p', [_vm._v("(1)基本信息(申请入驻的课程介绍、课程目录、上线后的更新规划、以往开课经验等)；")]), _vm._v(" "), _c('p', [_vm._v("(2)资质信息(机构类提供最新营业执照扫描件、个人类提供教师资格证书/专业资格证书/高等学历扫描件)。")])]), _vm._v(" "), _c('div', {
    staticClass: "line-title"
  }, [_vm._v("3. 接收邮箱：")]), _vm._v(" "), _c('div', {
    staticClass: "line-content"
  }, [_c('a', {
    staticStyle: {
      "color": "#0a9aeb"
    },
    attrs: {
      "href": "mailto:edubot@hitrobotgroup.com"
    }
  }, [_vm._v("edubot@hitrobotgroup.com")])]), _vm._v(" "), _c('div', {
    staticClass: "corner"
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-10c20e7a","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Settle.vue
// module id = 368
// module chunks = 1